import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    navbar: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      careers: 'Careers',
      contact: 'Contact',
      getQuote: 'Get a Quote'
    },
    home: {
      badge: 'Trusted Manpower Provider',
      title: 'Professional',
      highlight: 'Manpower Services',
      titleEnd: 'for Your Business',
      description: 'MEDCoop provides skilled, trained, and reliable personnel for various industries. From janitorial to construction, we\'ve got your staffing needs covered.',
      personnel: 'Personnel',
      established: 'Established',
      coverage: 'Coverage',
      selectLanguage: 'Select Language',
      iAmA: 'I am a...',
      company: 'Company Looking for Services',
      individual: 'Individual Applying for Work',
      partnersTitle: 'Our Business Partners',
      partnersSubtitle: 'Trusted by leading companies across various industries',
      licensedBadge: 'Licensed & Accredited',
      certificatesTitle: 'Permits, Certificates & Licenses',
      certificatesSubtitle: 'Fully compliant with all government regulations and industry standards',
      ctaTitle: 'Need Reliable Manpower for Your Business?',
      ctaDescription: 'Partner with MEDCoop for your staffing needs. We provide skilled and trained personnel for various industries.',
      requestQuote: 'Contact Us',
      viewServices: 'View All Services'
    },
    about: {
      title: 'About MEDCoop',
      subtitle: 'Learn more about our cooperative and our commitment to excellence',
      ourStory: 'Our Story',
      visionMission: 'Vision & Mission',
      ourVision: 'Our Vision',
      ourMission: 'Our Mission',
      coreValues: 'Our Core Values',
      employeeBenefits: 'Employee Benefits',
      employeeBenefitsSubtitle: 'We take care of our personnel with complete statutory benefits',
      clearancesTitle: 'Required Clearances',
      clearancesSubtitle: 'All personnel undergo thorough screening',
      assurancesTitle: 'Client Assurances',
      tableOfOrg: 'Table of Organization',
      tableOfOrgSubtitle: 'Our leadership team ensuring quality service delivery',
      whyChoose: 'Why Choose MEDC',
      whyChooseSubtitle: 'Experience the MEDC advantage',
      partnerWithUs: 'Partner With Us',
      learnMore: 'Learn More'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Professional manpower services tailored to meet your business needs.',
      inquireNow: 'Inquire Now',
      howItWorks: 'How It Works',
      howItWorksSubtitle: 'Simple steps to get the manpower you need',
      faq: 'Frequently Asked Questions',
      faqSubtitle: 'Find answers to common questions about our services',
      janitorial: 'Janitorial Services',
      janitorialDesc: 'Professional cleaning and maintenance services for offices, buildings, and commercial establishments.',
      messengers: 'Messengers/Collectors',
      messengersDesc: 'Reliable messenger and collection services for documents, payments, and deliveries.',
      drivers: 'Company Drivers',
      driversDesc: 'Professional and licensed drivers for your company vehicles and transportation needs.',
      construction: 'Construction Workers',
      constructionDesc: 'Skilled construction workers for building projects, renovations, and maintenance work.',
      promotion: 'Promotion Merchandisers',
      promotionDesc: 'Trained merchandisers for product promotions, displays, and retail support.',
      cctv: 'CCTV Operators',
      cctvDesc: 'Trained security personnel for CCTV monitoring and surveillance operations.',
      radio: 'Radio Operators',
      radioDesc: 'Professional radio operators for communication and coordination services.',
      carpet: 'Carpet Shampooing',
      carpetDesc: 'Professional carpet and upholstery cleaning services for offices and commercial spaces.',
      clerks: 'Office Temp Clerks',
      clerksDesc: 'Temporary clerical staff for administrative support and office operations.',
      cashSorters: 'Cash Sorters',
      cashSortersDesc: 'Trained personnel for cash handling, sorting, and counting operations.',
      concierge: 'Concierge Services',
      conciergeDesc: 'Professional concierge staff for buildings, hotels, and corporate establishments.',
      otherServices: 'Other Allied Services',
      otherServicesDesc: 'Comprehensive manpower solutions for various business needs and requirements.',
      contactUs: 'Contact Us',
      contactUsDesc: 'Reach out to discuss your manpower requirements.',
      assessment: 'Assessment',
      assessmentDesc: 'We assess your needs and provide a customized proposal.',
      deployment: 'Deployment',
      deploymentDesc: 'Trained personnel are deployed to your location.',
      monitoring: 'Monitoring',
      monitoringDesc: 'Continuous supervision and quality assurance.',
      recruitmentProcess: 'Recruitment Process',
      recruitmentSubtitle: 'Our thorough process ensures quality personnel',
      needsAnalysis: 'Needs Analysis',
      processingPhase: 'Processing Phase',
      eliminationProcess: 'Elimination Process',
      selectionProcess: 'Selection Process',
      requirements: 'Requirements Checklist',
      requirementsSubtitle: 'Documents needed for application',
      faqQ1: 'What services does MEDCoop offer?',
      faqA1: 'We offer a wide range of manpower services including janitorial, messengers/collectors, company drivers, construction workers, promotion merchandisers, CCTV operators, radio operators, carpet shampooing, office temp clerks, cash sorters, concierge, and other allied services.',
      faqQ2: 'How do I request manpower services?',
      faqA2: 'You can contact us via phone at (082) 285 1120 or (082) 224 6036, visit our office at 3rd Floor Marcela Bldg. Palma Gil St. Brgy. 34-D, Davao City, or fill out our online inquiry form.',
      faqQ3: 'Are your workers trained and screened?',
      faqA3: 'Yes, all our personnel undergo thorough background checks, skills assessment, and training before deployment. We ensure that our workers meet industry standards and your specific requirements.',
      faqQ4: 'Can I request short-term or temporary staff?',
      faqA4: 'Absolutely! We offer flexible staffing solutions including short-term, long-term, and project-based contracts to meet your specific needs.',
      faqQ5: 'What areas do you serve?',
      faqA5: 'We primarily serve Davao City and surrounding areas. Contact us for service availability in your location.'
    },
    careers: {
      title: 'Join Our Team',
      subtitle: 'Be part of a growing cooperative that values its members',
      whyJoin: 'Why Join MEDCoop?',
      applyNow: 'Apply Now',
      chooseCareerPath: 'Choose Your Career Path',
      chooseCareerPathSubtitle: 'Select the option that best describes what you\'re looking for',
      fieldServiceWorker: 'Field Service Worker',
      fieldWorkerDesc: 'Apply for deployment to our partner companies as a service worker',
      officeStaff: 'Office Staff',
      officeStaffDesc: 'Apply for administrative and office positions at MEDCoop',
      applyAsFieldWorker: 'Apply as Field Worker',
      applyAsOfficeStaff: 'Apply as Office Staff',
      janitorialStaff: 'Janitorial Staff',
      messengerCollector: 'Messenger/Collector',
      companyDriver: 'Company Driver',
      constructionWorker: 'Construction Worker',
      andMore: 'And more...',
      accounting: 'Accounting',
      humanResources: 'Human Resources',
      adminSupport: 'Admin Support',
      itSupport: 'IT Support'
    },
    application: {
      employeeInfoSheet: 'Employee\'s Information Sheet',
      fieldWorkerApplication: 'MEDCoop - Field Service Worker Application',
      officeStaffApplication: 'MEDCoop - Office Staff Application',
      backToOptions: 'Back to Options',
      previousStep: 'Previous Step',
      nextStep: 'Next Step',
      submitApplication: 'Submit Application',
      personalInfo: 'Personal Info',
      familyBackground: 'Family Background',
      educationSkills: 'Education & Skills',
      employmentHistory: 'Employment History',
      reviewSubmit: 'Review & Submit',
      personalInformation: 'Personal Information',
      governmentIds: 'Government IDs',
      contactInformation: 'Contact Information',
      emergencyContact: 'Person to Contact in Case of Emergency',
      spouseInformation: 'Spouse Information',
      childrenInfo: 'Name of Children',
      parentsInfo: 'Parents Information',
      siblingsInfo: 'Siblings Information',
      educationalBackground: 'Educational Background',
      specialSkills: 'Special Skills',
      jobPreferences: 'Job Preferences',
      positionApplied: 'Position Applied',
      employmentBackground: 'Employment Background',
      characterReferences: 'Character References',
      lastName: 'Last Name',
      firstName: 'First Name',
      middleName: 'Middle Name',
      age: 'Age',
      sex: 'Sex',
      male: 'Male',
      female: 'Female',
      height: 'Height (cm)',
      weight: 'Weight (kg)',
      religion: 'Religion',
      bloodType: 'Blood Type',
      civilStatus: 'Civil Status',
      single: 'Single',
      married: 'Married',
      separated: 'Separated',
      widower: 'Widower',
      birthdate: 'Birthdate',
      birthPlace: 'Birth Place',
      sssNo: 'SSS No.',
      philhealthNo: 'PhilHealth No.',
      pagibigNo: 'HDMF/Pag-IBIG No.',
      tinNo: 'TIN',
      contactNumber: 'Contact Number',
      emailAddress: 'Email Address',
      driversLicense: 'Driver\'s License No.',
      licenseExpiry: 'License Expiry Date',
      cityAddress: 'City Address',
      addressType: 'Address Type',
      owned: 'Owned',
      rented: 'Rented',
      boardingHouse: 'Boarding House',
      provincialAddress: 'Provincial Address',
      name: 'Name',
      relation: 'Relation',
      address: 'Address',
      contactNo: 'Contact No.',
      spouse: 'Spouse',
      sibling: 'Sibling',
      parent: 'Parent',
      relative: 'Relative',
      others: 'Others',
      nameOfSpouse: 'Name of Spouse',
      occupation: 'Occupation',
      childName: 'Child Name',
      childAge: 'Age',
      fatherName: 'Father\'s Name',
      motherName: 'Mother\'s Name',
      siblingName: 'Sibling Name',
      elementary: 'Elementary',
      highSchool: 'High School',
      college: 'College',
      vocational: 'Vocational/Technical',
      schoolName: 'School Name',
      yearGraduated: 'Year Graduated',
      course: 'Course/Program',
      specialSkillsPlaceholder: 'Enter your skills separated by commas',
      preferredPosition: 'Preferred Position',
      selectPosition: 'Select Position',
      preferredLocation: 'Preferred Work Location',
      selectLocation: 'Select Location',
      specifyService: 'Please specify the service you are applying for',
      specifyPosition: 'Please specify the position you are applying for',
      positionAppliedFor: 'Position Applied For',
      employer: 'Employer',
      designation: 'Designation',
      yearEmployed: 'Year Employed',
      salary: 'Salary',
      reasonForLeaving: 'Reason for Leaving',
      referenceName: 'Reference Name',
      referenceOccupation: 'Occupation',
      referenceAddress: 'Address',
      referenceContact: 'Contact Number',
      childrenHelperText: 'List up to 5 children (if applicable)',
      siblingsHelperText: 'List up to 4 siblings (if applicable)',
      employmentHelperText: 'Indicate current to past employment (up to 3)',
      referencesHelperText: 'Provide at least 2 character references',
      mostRecent: 'Most Recent',
      reviewTitle: 'Review Your Application',
      reviewSubtitle: 'Please review all information before submitting',
      notProvided: 'Not provided',
      edit: 'Edit',
      declaration: 'Declaration',
      declarationText: 'I hereby certify that the information provided above is true and correct to the best of my knowledge. I understand that any false statement may be grounds for disqualification or termination.',
      agreeToTerms: 'I agree to the terms and conditions and certify that all information provided is accurate.',
      fillRequiredFields: 'Please fill in all required fields before proceeding.',
      lastNameRequired: 'Last name is required',
      firstNameRequired: 'First name is required',
      ageRequired: 'Valid age (18+) is required',
      sexRequired: 'Sex is required',
      civilStatusRequired: 'Civil status is required',
      birthdateRequired: 'Birthdate is required',
      birthPlaceRequired: 'Birth place is required',
      contactNumberRequired: 'Contact number is required',
      contactNumber11Digits: 'Contact number must be exactly 11 digits',
      cityAddressRequired: 'City address is required',
      emergencyNameRequired: 'Emergency contact name is required',
      emergencyRelationRequired: 'Emergency contact relation is required',
      emergencyAddressRequired: 'Emergency contact address is required',
      emergencyContactRequired: 'Emergency contact number is required',
      emergencyContact11Digits: 'Emergency contact must be exactly 11 digits',
      preferredPositionRequired: 'Preferred position is required',
      specifyServiceRequired: 'Please specify the service you are applying for',
      preferredLocationRequired: 'Preferred location is required',
      positionAppliedRequired: 'Position applied is required',
      specifyPositionRequired: 'Please specify the position you are applying for',
      agreeRequired: 'You must agree to the terms and conditions',
      applicationSubmitted: 'Application Submitted Successfully!',
      thankYou: 'Thank you for your application. We will review your information and contact you soon.',
      submitting: 'Submitting...'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with us for inquiries and partnerships',
      sendMessage: 'Send Message',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      yourPhone: 'Your Phone',
      subject: 'Subject',
      message: 'Message',
      ourLocation: 'Our Location',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      officeHours: 'Office Hours',
      getInTouch: 'Get In Touch',
      sendUsMessage: 'Send Us a Message'
    },
    footer: {
      description: 'Your trusted manpower services provider since 1997. CDA Registered Cooperative serving Luzon, Visayas, and Mindanao.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contactInfo: 'Contact Info',
      allRightsReserved: 'All rights reserved.',
      cdaRegistered: 'CDA Registered'
    },
    common: {
      learnMore: 'Learn More',
      readMore: 'Read More',
      submit: 'Submit',
      loading: 'Loading...',
      viewAll: 'View All',
      contactUs: 'Contact Us',
      select: 'Select',
      required: 'Required'
    }
  },
  tl: {
    navbar: {
      home: 'Home',
      about: 'Tungkol',
      services: 'Serbisyo',
      careers: 'Trabaho',
      contact: 'Kontak',
      getQuote: 'Kumuha ng Quotation'
    },
    home: {
      badge: 'Tagapagbigay ng Manggagawa',
      title: 'Propesyonal na',
      highlight: 'Serbisyo ng Manggagawa',
      titleEnd: 'para sa Iyong Negosyo',
      description: 'Ang MEDCoop ay nagbibigay ng may kasanayan, sinanay, at mapagkakatiwalaang tauhan para sa iba\'t ibang industriya.',
      personnel: 'Tauhan',
      established: 'Itinatag',
      coverage: 'Saklaw',
      selectLanguage: 'Pumili ng Wika',
      iAmA: 'Ako ay isang...',
      company: 'Kumpanyang Naghahanap ng Serbisyo',
      individual: 'Nag-aaplay para sa Trabaho',
      partnersTitle: 'Aming mga Business Partners',
      partnersSubtitle: 'Pinagkakatiwalaan ng mga nangungunang kumpanya',
      licensedBadge: 'Lisensyado at Akreditado',
      certificatesTitle: 'Mga Permit, Sertipiko at Lisensya',
      certificatesSubtitle: 'Ganap na sumusunod sa lahat ng regulasyon ng gobyerno at mga pamantayan ng industriya',
      ctaTitle: 'Kailangan ng Manggagawa para sa Iyong Negosyo?',
      ctaDescription: 'Makipagsosyo sa MEDCoop para sa iyong mga pangangailangan sa staffing.',
      requestQuote: 'Humiling ng Quotation',
      viewServices: 'Tingnan ang Serbisyo'
    },
    about: {
      title: 'Tungkol sa MEDCoop',
      subtitle: 'Alamin ang higit pa tungkol sa aming kooperatiba',
      ourStory: 'Aming Kwento',
      visionMission: 'Bisyon at Misyon',
      ourVision: 'Aming Bisyon',
      ourMission: 'Aming Misyon',
      coreValues: 'Mga Pangunahing Halaga',
      employeeBenefits: 'Mga Benepisyo ng Empleyado',
      employeeBenefitsSubtitle: 'Inaalagaan namin ang aming mga tauhan',
      clearancesTitle: 'Mga Kinakailangang Clearance',
      clearancesSubtitle: 'Lahat ng tauhan ay sumasailalim sa masusing pagsusuri',
      assurancesTitle: 'Mga Garantiya sa Kliyente',
      tableOfOrg: 'Organisasyon',
      tableOfOrgSubtitle: 'Aming pangkat ng pamunuan',
      whyChoose: 'Bakit Piliin ang MEDC',
      whyChooseSubtitle: 'Maranasan ang bentahe ng MEDC',
      partnerWithUs: 'Makipagsosyo sa Amin',
      learnMore: 'Alamin Pa'
    },
    services: {
      title: 'Aming mga Serbisyo',
      subtitle: 'Propesyonal na serbisyo ng manggagawa para sa iyong negosyo.',
      inquireNow: 'Magtanong Ngayon',
      howItWorks: 'Paano Ito Gumagana',
      howItWorksSubtitle: 'Simpleng hakbang para makuha ang manggagawa na kailangan mo',
      faq: 'Mga Madalas Itanong',
      faqSubtitle: 'Mga sagot sa karaniwang tanong tungkol sa aming serbisyo',
      janitorial: 'Serbisyong Janitorial',
      janitorialDesc: 'Propesyonal na serbisyo ng paglilinis at pagmamantina para sa mga opisina, gusali, at komersyal na establisyimento.',
      messengers: 'Mga Messenger/Kolektor',
      messengersDesc: 'Mapagkakatiwalaang serbisyo ng messenger at koleksyon para sa mga dokumento, bayarin, at paghahatid.',
      drivers: 'Mga Driver ng Kumpanya',
      driversDesc: 'Propesyonal at lisensyadong mga driver para sa mga sasakyan ng iyong kumpanya.',
      construction: 'Mga Manggagawa sa Konstruksyon',
      constructionDesc: 'Mahuhusay na manggagawa sa konstruksyon para sa mga proyekto ng gusali at pagmamantina.',
      promotion: 'Mga Promotion Merchandiser',
      promotionDesc: 'Sinanay na mga merchandiser para sa promosyon ng produkto at suporta sa retail.',
      cctv: 'Mga CCTV Operator',
      cctvDesc: 'Sinanay na tauhan ng seguridad para sa pagmamanman ng CCTV.',
      radio: 'Mga Radio Operator',
      radioDesc: 'Propesyonal na mga radio operator para sa komunikasyon at koordinasyon.',
      carpet: 'Carpet Shampooing',
      carpetDesc: 'Propesyonal na serbisyo ng paglilinis ng carpet at upholstery.',
      clerks: 'Pansamantalang Clerk sa Opisina',
      clerksDesc: 'Pansamantalang kawani para sa suportang administratibo at operasyon sa opisina.',
      cashSorters: 'Mga Cash Sorter',
      cashSortersDesc: 'Sinanay na tauhan para sa paghawak, pag-aayos, at pagbibilang ng pera.',
      concierge: 'Serbisyong Concierge',
      conciergeDesc: 'Propesyonal na tauhan ng concierge para sa mga gusali at hotel.',
      otherServices: 'Iba Pang Kaugnay na Serbisyo',
      otherServicesDesc: 'Komprehensibong solusyon sa manggagawa para sa iba\'t ibang pangangailangan ng negosyo.',
      contactUs: 'Makipag-ugnayan',
      contactUsDesc: 'Makipag-ugnayan para sa iyong mga pangangailangan sa manggagawa.',
      assessment: 'Pagsusuri',
      assessmentDesc: 'Susuriin namin ang iyong mga pangangailangan at magbibigay ng pasadyang panukala.',
      deployment: 'Deployment',
      deploymentDesc: 'Ang sinanay na tauhan ay ide-deploy sa iyong lokasyon.',
      monitoring: 'Pagmamanman',
      monitoringDesc: 'Patuloy na pangangasiwa at pagtitiyak ng kalidad.',
      recruitmentProcess: 'Proseso ng Recruitment',
      recruitmentSubtitle: 'Ang aming masusing proseso ay nagtitiyak ng kalidad na tauhan',
      needsAnalysis: 'Pagsusuri ng Pangangailangan',
      processingPhase: 'Yugto ng Pagproseso',
      eliminationProcess: 'Proseso ng Eliminasyon',
      selectionProcess: 'Proseso ng Pagpili',
      requirements: 'Listahan ng mga Kinakailangan',
      requirementsSubtitle: 'Mga dokumentong kailangan para sa aplikasyon',
      faqQ1: 'Anong mga serbisyo ang inaalok ng MEDCoop?',
      faqA1: 'Nag-aalok kami ng malawak na serbisyo sa manggagawa kabilang ang janitorial, messenger/kolektor, driver ng kumpanya, manggagawa sa konstruksyon, promotion merchandiser, CCTV operator, radio operator, carpet shampooing, pansamantalang clerk, cash sorter, concierge, at iba pang kaugnay na serbisyo.',
      faqQ2: 'Paano ako makakahingi ng serbisyo sa manpower?',
      faqA2: 'Maaari kang makipag-ugnayan sa amin sa telepono (082) 285 1120 o (082) 224 6036, bisitahin ang aming opisina sa 3rd Floor Marcela Bldg. Palma Gil St. Brgy. 34-D, Davao City, o punan ang aming online inquiry form.',
      faqQ3: 'Ang inyong mga manggagawa ba ay sinanay at sinuri?',
      faqA3: 'Oo, lahat ng aming tauhan ay sumasailalim sa masusing background check, pagsusuri ng kasanayan, at pagsasanay bago i-deploy.',
      faqQ4: 'Maaari ba akong humiling ng panandalian o pansamantalang tauhan?',
      faqA4: 'Oo! Nag-aalok kami ng flexible na solusyon sa staffing kabilang ang panandalian, pangmatagalan, at kontratang batay sa proyekto.',
      faqQ5: 'Anong mga lugar ang inyong pinaglilingkuran?',
      faqA5: 'Pangunahin naming pinaglilingkuran ang Davao City at mga kalapit na lugar. Makipag-ugnayan sa amin para sa pagkakaroon ng serbisyo sa iyong lokasyon.'
    },
    careers: {
      title: 'Sumali sa Aming Kooperatiba',
      subtitle: 'Maging bahagi ng lumalagong kooperatiba',
      whyJoin: 'Bakit Sumali sa MEDCoop?',
      applyNow: 'Mag-apply Ngayon',
      chooseCareerPath: 'Pumili ng Iyong Career Path',
      chooseCareerPathSubtitle: 'Piliin ang opsyon na pinakanaglalarawan sa iyong hinahanap',
      fieldServiceWorker: 'Field Service Worker',
      fieldWorkerDesc: 'Mag-apply para sa deployment sa aming mga partner company bilang service worker',
      officeStaff: 'Staff ng Opisina',
      officeStaffDesc: 'Mag-apply para sa mga posisyong administratibo at opisina sa MEDCoop',
      applyAsFieldWorker: 'Mag-apply bilang Field Worker',
      applyAsOfficeStaff: 'Mag-apply bilang Office Staff',
      janitorialStaff: 'Janitorial Staff',
      messengerCollector: 'Messenger/Kolektor',
      companyDriver: 'Driver ng Kumpanya',
      constructionWorker: 'Manggagawa sa Konstruksyon',
      andMore: 'At iba pa...',
      accounting: 'Accounting',
      humanResources: 'Human Resources',
      adminSupport: 'Admin Support',
      itSupport: 'IT Support'
    },
    application: {
      employeeInfoSheet: 'Employee\'s Information Sheet',
      fieldWorkerApplication: 'MEDCoop - Aplikasyon para sa Field Service Worker',
      officeStaffApplication: 'MEDCoop - Aplikasyon para sa Office Staff',
      backToOptions: 'Bumalik sa mga Opsyon',
      previousStep: 'Nakaraang Hakbang',
      nextStep: 'Susunod na Hakbang',
      submitApplication: 'Isumite ang Aplikasyon',
      personalInfo: 'Personal na Impormasyon',
      familyBackground: 'Background ng Pamilya',
      educationSkills: 'Edukasyon at Kasanayan',
      employmentHistory: 'Kasaysayan ng Trabaho',
      reviewSubmit: 'Suriin at Isumite',
      personalInformation: 'Personal na Impormasyon',
      governmentIds: 'Mga Government ID',
      contactInformation: 'Impormasyon sa Pakikipag-ugnay',
      emergencyContact: 'Taong Kakausapin sa Emergency',
      spouseInformation: 'Impormasyon ng Asawa',
      childrenInfo: 'Pangalan ng mga Anak',
      parentsInfo: 'Impormasyon ng mga Magulang',
      siblingsInfo: 'Impormasyon ng mga Kapatid',
      educationalBackground: 'Edukasyonal na Background',
      specialSkills: 'Mga Espesyal na Kasanayan',
      jobPreferences: 'Mga Kagustuhan sa Trabaho',
      positionApplied: 'Posisyong Inaaplayan',
      employmentBackground: 'Background sa Trabaho',
      characterReferences: 'Mga Character Reference',
      lastName: 'Apelyido',
      firstName: 'Pangalan',
      middleName: 'Gitnang Pangalan',
      age: 'Edad',
      sex: 'Kasarian',
      male: 'Lalaki',
      female: 'Babae',
      height: 'Taas (cm)',
      weight: 'Timbang (kg)',
      religion: 'Relihiyon',
      bloodType: 'Uri ng Dugo',
      civilStatus: 'Katayuang Sibil',
      single: 'Walang Asawa',
      married: 'May Asawa',
      separated: 'Hiwalay',
      widower: 'Biyudo/Biyuda',
      birthdate: 'Petsa ng Kapanganakan',
      birthPlace: 'Lugar ng Kapanganakan',
      sssNo: 'SSS No.',
      philhealthNo: 'PhilHealth No.',
      pagibigNo: 'HDMF/Pag-IBIG No.',
      tinNo: 'TIN',
      contactNumber: 'Numero ng Telepono',
      emailAddress: 'Email Address',
      driversLicense: 'Numero ng Lisensya sa Pagmamaneho',
      licenseExpiry: 'Petsa ng Pagkawakas ng Lisensya',
      cityAddress: 'Address sa Lungsod',
      addressType: 'Uri ng Address',
      owned: 'Sariling-ari',
      rented: 'Nirerentahan',
      boardingHouse: 'Boarding House',
      provincialAddress: 'Address sa Probinsya',
      name: 'Pangalan',
      relation: 'Relasyon',
      address: 'Address',
      contactNo: 'Contact No.',
      spouse: 'Asawa',
      sibling: 'Kapatid',
      parent: 'Magulang',
      relative: 'Kamag-anak',
      others: 'Iba pa',
      nameOfSpouse: 'Pangalan ng Asawa',
      occupation: 'Trabaho',
      childName: 'Pangalan ng Anak',
      childAge: 'Edad',
      fatherName: 'Pangalan ng Ama',
      motherName: 'Pangalan ng Ina',
      siblingName: 'Pangalan ng Kapatid',
      elementary: 'Elementarya',
      highSchool: 'High School',
      college: 'Kolehiyo',
      vocational: 'Vocational/Technical',
      schoolName: 'Pangalan ng Paaralan',
      yearGraduated: 'Taon ng Pagtatapos',
      course: 'Kurso/Programa',
      specialSkillsPlaceholder: 'Ilagay ang iyong mga kasanayan na pinaghihiwalay ng kuwit',
      preferredPosition: 'Gustong Posisyon',
      selectPosition: 'Pumili ng Posisyon',
      preferredLocation: 'Gustong Lugar ng Trabaho',
      selectLocation: 'Pumili ng Lokasyon',
      specifyService: 'Pakitukoy ang serbisyong iyong inaaplayan',
      specifyPosition: 'Pakitukoy ang posisyong iyong inaaplayan',
      positionAppliedFor: 'Posisyong Inaaplayan',
      employer: 'Employer',
      designation: 'Posisyon',
      yearEmployed: 'Taon ng Pagtatrabaho',
      salary: 'Sahod',
      reasonForLeaving: 'Dahilan ng Pag-alis',
      referenceName: 'Pangalan ng Reference',
      referenceOccupation: 'Trabaho',
      referenceAddress: 'Address',
      referenceContact: 'Numero ng Telepono',
      childrenHelperText: 'Ilista ang hanggang 5 anak (kung mayroon)',
      siblingsHelperText: 'Ilista ang hanggang 4 na kapatid (kung mayroon)',
      employmentHelperText: 'Isaad ang kasalukuyan hanggang nakaraang trabaho (hanggang 3)',
      referencesHelperText: 'Magbigay ng hindi bababa sa 2 character reference',
      mostRecent: 'Pinakabago',
      reviewTitle: 'Suriin ang Iyong Aplikasyon',
      reviewSubtitle: 'Pakisuri ang lahat ng impormasyon bago isumite',
      notProvided: 'Hindi ibinigay',
      edit: 'I-edit',
      declaration: 'Deklarasyon',
      declarationText: 'Pinapatunayan ko na ang impormasyong ibinigay sa itaas ay totoo at tama sa abot ng aking kaalaman. Nauunawaan ko na anumang maling pahayag ay maaaring maging dahilan ng diskwalipikasyon o pagwawakas.',
      agreeToTerms: 'Sumasang-ayon ako sa mga tuntunin at kundisyon at pinapatunayan na ang lahat ng impormasyong ibinigay ay tama.',
      fillRequiredFields: 'Pakipunan ang lahat ng kinakailangang field bago magpatuloy.',
      lastNameRequired: 'Kinakailangan ang apelyido',
      firstNameRequired: 'Kinakailangan ang pangalan',
      ageRequired: 'Kinakailangan ang wastong edad (18+)',
      sexRequired: 'Kinakailangan ang kasarian',
      civilStatusRequired: 'Kinakailangan ang katayuang sibil',
      birthdateRequired: 'Kinakailangan ang petsa ng kapanganakan',
      birthPlaceRequired: 'Kinakailangan ang lugar ng kapanganakan',
      contactNumberRequired: 'Kinakailangan ang numero ng telepono',
      contactNumber11Digits: 'Ang numero ng telepono ay dapat eksaktong 11 digits',
      cityAddressRequired: 'Kinakailangan ang address sa lungsod',
      emergencyNameRequired: 'Kinakailangan ang pangalan ng emergency contact',
      emergencyRelationRequired: 'Kinakailangan ang relasyon ng emergency contact',
      emergencyAddressRequired: 'Kinakailangan ang address ng emergency contact',
      emergencyContactRequired: 'Kinakailangan ang numero ng emergency contact',
      emergencyContact11Digits: 'Ang emergency contact ay dapat eksaktong 11 digits',
      preferredPositionRequired: 'Kinakailangan ang gustong posisyon',
      specifyServiceRequired: 'Pakitukoy ang serbisyong iyong inaaplayan',
      preferredLocationRequired: 'Kinakailangan ang gustong lokasyon',
      positionAppliedRequired: 'Kinakailangan ang posisyong inaaplayan',
      specifyPositionRequired: 'Pakitukoy ang posisyong iyong inaaplayan',
      agreeRequired: 'Dapat kang sumang-ayon sa mga tuntunin at kundisyon',
      applicationSubmitted: 'Matagumpay na Naisumite ang Aplikasyon!',
      thankYou: 'Salamat sa iyong aplikasyon. Susuriin namin ang iyong impormasyon at makikipag-ugnayan sa iyo sa lalong madaling panahon.',
      submitting: 'Isinusumite...'
    },
    contact: {
      title: 'Makipag-ugnayan',
      subtitle: 'Makipag-ugnayan sa amin para sa mga katanungan',
      sendMessage: 'Ipadala ang Mensahe',
      yourName: 'Iyong Pangalan',
      yourEmail: 'Iyong Email',
      yourPhone: 'Iyong Telepono',
      subject: 'Paksa',
      message: 'Mensahe',
      ourLocation: 'Aming Lokasyon',
      phone: 'Telepono',
      email: 'Email',
      address: 'Address',
      officeHours: 'Oras ng Opisina',
      getInTouch: 'Makipag-ugnayan',
      sendUsMessage: 'Magpadala ng Mensahe'
    },
    footer: {
      description: 'Ang iyong pinagkakatiwalaang tagapagbigay ng serbisyo sa manggagawa mula 1997.',
      quickLinks: 'Mabilisang Link',
      ourServices: 'Aming Serbisyo',
      contactInfo: 'Impormasyon sa Pakikipag-ugnay',
      allRightsReserved: 'Lahat ng karapatan ay nakalaan.',
      cdaRegistered: 'Rehistrado sa CDA'
    },
    common: {
      learnMore: 'Alamin Pa',
      readMore: 'Magbasa Pa',
      submit: 'Isumite',
      loading: 'Naglo-load...',
      viewAll: 'Tingnan Lahat',
      contactUs: 'Makipag-ugnayan',
      select: 'Pumili',
      required: 'Kinakailangan'
    }
  },
  ceb: {
    navbar: {
      home: 'Home',
      about: 'Mahitungod',
      services: 'Serbisyo',
      careers: 'Trabaho',
      contact: 'Kontak',
      getQuote: 'Pangayo og Quotation'
    },
    home: {
      badge: 'Kasaligan nga Tighatag sa Trabahante',
      title: 'Propesyonal nga',
      highlight: 'Serbisyo sa Manpower',
      titleEnd: 'para sa Imong Negosyo',
      description: 'Ang MEDCoop naghatag og hanas, bansay, ug kasaligan nga mga tawo para sa lain-laing mga industriya.',
      personnel: 'Tauhan',
      established: 'Gitukod',
      coverage: 'Ginsakupan',
      selectLanguage: 'Pagpili og Pinulongan',
      iAmA: 'Ako kay...',
      company: 'Kompanya nga Nangita og Serbisyo',
      individual: 'Mag-apply para sa Trabaho',
      partnersTitle: 'Among mga Business Partners',
      partnersSubtitle: 'Gisaligan sa mga nanguna nga kompanya',
      licensedBadge: 'Lisensyado ug Akreditado',
      certificatesTitle: 'Mga Permit, Sertipiko ug Lisensya',
      certificatesSubtitle: 'Bug-os nga nagsunod sa tanang regulasyon sa gobyerno ug mga pamantayan sa industriya',
      ctaTitle: 'Kinahanglan ba og Manpower para sa Imong Negosyo?',
      ctaDescription: 'Makig-partner sa MEDCoop para sa imong mga panginahanglan sa staffing.',
      requestQuote: 'Pangayo og Quotation',
      viewServices: 'Tan-awa ang Serbisyo'
    },
    about: {
      title: 'Mahitungod sa MEDCoop',
      subtitle: 'Pagkat-on og dugang mahitungod sa among kooperatiba',
      ourStory: 'Among Istorya',
      visionMission: 'Bisyon ug Misyon',
      ourVision: 'Among Bisyon',
      ourMission: 'Among Misyon',
      coreValues: 'Mga Nag-unang Bili',
      employeeBenefits: 'Mga Benepisyo sa Empleyado',
      employeeBenefitsSubtitle: 'Among gialagaan ang among mga tauhan',
      clearancesTitle: 'Gikinahanglan nga mga Clearance',
      clearancesSubtitle: 'Tanang tauhan nag-agi sa maayong pagsusi',
      assurancesTitle: 'Mga Garantiya sa Kliyente',
      tableOfOrg: 'Organisasyon',
      tableOfOrgSubtitle: 'Among grupo sa pagpangulo',
      whyChoose: 'Ngano Pilion ang MEDC',
      whyChooseSubtitle: 'Sulayi ang bentaha sa MEDC',
      partnerWithUs: 'Makig-partner Kanamo',
      learnMore: 'Pagkat-on Pa'
    },
    services: {
      title: 'Among mga Serbisyo',
      subtitle: 'Propesyonal nga serbisyo sa manpower para sa imong negosyo.',
      inquireNow: 'Mangutana Karon',
      howItWorks: 'Unsaon Kini Pagtrabaho',
      howItWorksSubtitle: 'Sayon nga mga lakang aron makuha ang manpower nga imong gikinahanglan',
      faq: 'Kanunay nga Gipangutana',
      faqSubtitle: 'Mga tubag sa kasagaran nga pangutana mahitungod sa among serbisyo',
      janitorial: 'Serbisyong Janitorial',
      janitorialDesc: 'Propesyonal nga serbisyo sa paglimpyo ug pagmintinar para sa mga opisina, bilding, ug komersyal nga establisyimento.',
      messengers: 'Mga Messenger/Kolektor',
      messengersDesc: 'Kasaligan nga serbisyo sa messenger ug koleksyon para sa mga dokumento, bayad, ug delivery.',
      drivers: 'Mga Driver sa Kompanya',
      driversDesc: 'Propesyonal ug lisensyado nga mga driver para sa mga sakyanan sa imong kompanya.',
      construction: 'Mga Trabahante sa Konstruksyon',
      constructionDesc: 'Hanas nga mga trabahante sa konstruksyon para sa mga proyekto sa bilding ug pagmintinar.',
      promotion: 'Mga Promotion Merchandiser',
      promotionDesc: 'Gibansay nga mga merchandiser para sa promosyon sa produkto ug suporta sa retail.',
      cctv: 'Mga CCTV Operator',
      cctvDesc: 'Gibansay nga tauhan sa seguridad para sa pagbantay sa CCTV.',
      radio: 'Mga Radio Operator',
      radioDesc: 'Propesyonal nga mga radio operator para sa komunikasyon ug koordinasyon.',
      carpet: 'Carpet Shampooing',
      carpetDesc: 'Propesyonal nga serbisyo sa paglimpyo sa carpet ug upholstery.',
      clerks: 'Temporaryo nga Clerk sa Opisina',
      clerksDesc: 'Temporaryo nga kawani para sa administratibo nga suporta ug operasyon sa opisina.',
      cashSorters: 'Mga Cash Sorter',
      cashSortersDesc: 'Gibansay nga tauhan para sa paghawid, pag-sort, ug pagkwenta sa kwarta.',
      concierge: 'Serbisyong Concierge',
      conciergeDesc: 'Propesyonal nga tauhan sa concierge para sa mga bilding ug hotel.',
      otherServices: 'Uban pang Kauban nga Serbisyo',
      otherServicesDesc: 'Komprehensibo nga solusyon sa manpower para sa lain-laing panginahanglan sa negosyo.',
      contactUs: 'Kontaka Kami',
      contactUsDesc: 'Makig-uban para sa imong mga panginahanglan sa manpower.',
      assessment: 'Pagsusi',
      assessmentDesc: 'Among susihon ang imong mga panginahanglan ug maghatag og pasadya nga proposisyon.',
      deployment: 'Deployment',
      deploymentDesc: 'Ang gibansay nga tauhan i-deploy sa imong lokasyon.',
      monitoring: 'Pagbantay',
      monitoringDesc: 'Padayon nga pagpangulo ug pagsiguro sa kalidad.',
      recruitmentProcess: 'Proseso sa Recruitment',
      recruitmentSubtitle: 'Ang among masinaw nga proseso nagsiguro sa kalidad nga tauhan',
      needsAnalysis: 'Pagsusi sa Panginahanglan',
      processingPhase: 'Yugto sa Pagproseso',
      eliminationProcess: 'Proseso sa Eliminasyon',
      selectionProcess: 'Proseso sa Pagpili',
      requirements: 'Listahan sa mga Gikinahanglan',
      requirementsSubtitle: 'Mga dokumento nga gikinahanglan para sa aplikasyon',
      faqQ1: 'Unsang mga serbisyo ang gitanyag sa MEDCoop?',
      faqA1: 'Nagtanyag kami og daghang serbisyo sa manpower lakip ang janitorial, messenger/kolektor, driver sa kompanya, trabahante sa konstruksyon, promotion merchandiser, CCTV operator, radio operator, carpet shampooing, temporaryo nga clerk, cash sorter, concierge, ug uban pang kauban nga serbisyo.',
      faqQ2: 'Unsaon nako pagpangayo og serbisyo sa manpower?',
      faqA2: 'Mahimo kang makig-uban kanamo pinaagi sa telepono (082) 285 1120 o (082) 224 6036, bisitaha ang among opisina sa 3rd Floor Marcela Bldg. Palma Gil St. Brgy. 34-D, Davao City, o pun-a ang among online inquiry form.',
      faqQ3: 'Ang inyong mga trabahante ba gibansay ug gisusi?',
      faqA3: 'Oo, tanang among tauhan nag-agi sa masinaw nga background check, pagsusi sa kahanas, ug pagbansay sa wala pa i-deploy.',
      faqQ4: 'Mahimo ba akong mangayo og short-term o temporaryo nga tauhan?',
      faqA4: 'Oo! Nagtanyag kami og flexible nga solusyon sa staffing lakip ang short-term, long-term, ug kontrata base sa proyekto.',
      faqQ5: 'Unsang mga lugar ang inyong gialagaran?',
      faqA5: 'Nag-una kami pag-alagad sa Davao City ug mga kauban nga lugar. Kontaka kami para sa pagka-available sa serbisyo sa imong lokasyon.'
    },
    careers: {
      title: 'Apil sa Among Team',
      subtitle: 'Mahimong bahin sa nagtubo nga kooperatiba',
      whyJoin: 'Ngano Mag-apil sa MEDCoop?',
      applyNow: 'Mag-apply Karon',
      chooseCareerPath: 'Pagpili sa Imong Career Path',
      chooseCareerPathSubtitle: 'Pagpili sa opsyon nga pinaka-angay sa imong gipangita',
      fieldServiceWorker: 'Field Service Worker',
      fieldWorkerDesc: 'Mag-apply para sa deployment sa among mga partner company isip service worker',
      officeStaff: 'Staff sa Opisina',
      officeStaffDesc: 'Mag-apply para sa mga administratibo ug opisina nga posisyon sa MEDCoop',
      applyAsFieldWorker: 'Mag-apply isip Field Worker',
      applyAsOfficeStaff: 'Mag-apply isip Office Staff',
      janitorialStaff: 'Janitorial Staff',
      messengerCollector: 'Messenger/Kolektor',
      companyDriver: 'Driver sa Kompanya',
      constructionWorker: 'Trabahante sa Konstruksyon',
      andMore: 'Ug daghan pa...',
      accounting: 'Accounting',
      humanResources: 'Human Resources',
      adminSupport: 'Admin Support',
      itSupport: 'IT Support'
    },
    application: {
      employeeInfoSheet: 'Employee\'s Information Sheet',
      fieldWorkerApplication: 'MEDCoop - Aplikasyon para sa Field Service Worker',
      officeStaffApplication: 'MEDCoop - Aplikasyon para sa Office Staff',
      backToOptions: 'Balik sa mga Opsyon',
      previousStep: 'Nauna nga Lakang',
      nextStep: 'Sunod nga Lakang',
      submitApplication: 'Isumite ang Aplikasyon',
      personalInfo: 'Personal nga Impormasyon',
      familyBackground: 'Background sa Pamilya',
      educationSkills: 'Edukasyon ug Kahanas',
      employmentHistory: 'Kasaysayan sa Trabaho',
      reviewSubmit: 'Susiha ug Isumite',
      personalInformation: 'Personal nga Impormasyon',
      governmentIds: 'Mga Government ID',
      contactInformation: 'Impormasyon sa Pakig-uban',
      emergencyContact: 'Tawo nga Kontakon sa Emergency',
      spouseInformation: 'Impormasyon sa Asawa',
      childrenInfo: 'Mga Ngalan sa mga Anak',
      parentsInfo: 'Impormasyon sa mga Ginikanan',
      siblingsInfo: 'Impormasyon sa mga Igsoon',
      educationalBackground: 'Edukasyonal nga Background',
      specialSkills: 'Espesyal nga mga Kahanas',
      jobPreferences: 'Mga Gusto sa Trabaho',
      positionApplied: 'Posisyon nga Giaplay-an',
      employmentBackground: 'Background sa Trabaho',
      characterReferences: 'Mga Character Reference',
      lastName: 'Apelyido',
      firstName: 'Ngalan',
      middleName: 'Tungang Ngalan',
      age: 'Edad',
      sex: 'Sekso',
      male: 'Lalaki',
      female: 'Babaye',
      height: 'Gitas-on (cm)',
      weight: 'Gibug-aton (kg)',
      religion: 'Relihiyon',
      bloodType: 'Tipo sa Dugo',
      civilStatus: 'Sibil nga Kahimtang',
      single: 'Ulitawo/Dalaga',
      married: 'Minyo',
      separated: 'Bulag',
      widower: 'Biyudo/Biyuda',
      birthdate: 'Petsa sa Pagkatawo',
      birthPlace: 'Lugar sa Pagkatawo',
      sssNo: 'SSS No.',
      philhealthNo: 'PhilHealth No.',
      pagibigNo: 'HDMF/Pag-IBIG No.',
      tinNo: 'TIN',
      contactNumber: 'Numero sa Telepono',
      emailAddress: 'Email Address',
      driversLicense: 'Numero sa Driver\'s License',
      licenseExpiry: 'Petsa sa Pagkawagtang sa Lisensya',
      cityAddress: 'Address sa Siyudad',
      addressType: 'Tipo sa Address',
      owned: 'Kaugalingon',
      rented: 'Giabangan',
      boardingHouse: 'Boarding House',
      provincialAddress: 'Address sa Probinsya',
      name: 'Ngalan',
      relation: 'Relasyon',
      address: 'Address',
      contactNo: 'Contact No.',
      spouse: 'Asawa',
      sibling: 'Igsoon',
      parent: 'Ginikanan',
      relative: 'Paryente',
      others: 'Uban pa',
      nameOfSpouse: 'Ngalan sa Asawa',
      occupation: 'Trabaho',
      childName: 'Ngalan sa Anak',
      childAge: 'Edad',
      fatherName: 'Ngalan sa Amahan',
      motherName: 'Ngalan sa Inahan',
      siblingName: 'Ngalan sa Igsoon',
      elementary: 'Elementarya',
      highSchool: 'High School',
      college: 'Kolehiyo',
      vocational: 'Vocational/Technical',
      schoolName: 'Ngalan sa Eskwelahan',
      yearGraduated: 'Tuig sa Paggraduwar',
      course: 'Kurso/Programa',
      specialSkillsPlaceholder: 'Isulod ang imong mga kahanas nga gibulag sa koma',
      preferredPosition: 'Gusto nga Posisyon',
      selectPosition: 'Pagpili og Posisyon',
      preferredLocation: 'Gusto nga Lugar sa Trabaho',
      selectLocation: 'Pagpili og Lokasyon',
      specifyService: 'Palihog itukod ang serbisyo nga imong giaplay-an',
      specifyPosition: 'Palihog itukod ang posisyon nga imong giaplay-an',
      positionAppliedFor: 'Posisyon nga Giaplay-an',
      employer: 'Employer',
      designation: 'Posisyon',
      yearEmployed: 'Tuig sa Pagtrabaho',
      salary: 'Suweldo',
      reasonForLeaving: 'Rason sa Pagbiya',
      referenceName: 'Ngalan sa Reference',
      referenceOccupation: 'Trabaho',
      referenceAddress: 'Address',
      referenceContact: 'Numero sa Telepono',
      childrenHelperText: 'Ilista ang hangtod 5 ka anak (kung naay)',
      siblingsHelperText: 'Ilista ang hangtod 4 ka igsoon (kung naay)',
      employmentHelperText: 'Itukod ang kasamtangan hangtod sa nangagi nga trabaho (hangtod 3)',
      referencesHelperText: 'Maghatag og labing menos 2 ka character reference',
      mostRecent: 'Pinakabag-o',
      reviewTitle: 'Susiha ang Imong Aplikasyon',
      reviewSubtitle: 'Palihog susiha ang tanang impormasyon sa wala pa isumite',
      notProvided: 'Wala gihatag',
      edit: 'I-edit',
      declaration: 'Deklarasyon',
      declarationText: 'Ginapamatud-an nako nga ang impormasyon nga gihatag sa ibabaw kay tinuod ug husto kutob sa akong nahibal-an. Nakasabot ko nga bisan unsang bakak nga pahayag mahimong hinungdan sa diskwalipikasyon o pagwagtang.',
      agreeToTerms: 'Mouyon ko sa mga termino ug kondisyon ug ginapamatud-an nga ang tanang impormasyon nga gihatag kay husto.',
      fillRequiredFields: 'Palihog pun-a ang tanang gikinahanglan nga field sa wala pa magpadayon.',
      lastNameRequired: 'Gikinahanglan ang apelyido',
      firstNameRequired: 'Gikinahanglan ang ngalan',
      ageRequired: 'Gikinahanglan ang husto nga edad (18+)',
      sexRequired: 'Gikinahanglan ang sekso',
      civilStatusRequired: 'Gikinahanglan ang sibil nga kahimtang',
      birthdateRequired: 'Gikinahanglan ang petsa sa pagkatawo',
      birthPlaceRequired: 'Gikinahanglan ang lugar sa pagkatawo',
      contactNumberRequired: 'Gikinahanglan ang numero sa telepono',
      contactNumber11Digits: 'Ang numero sa telepono kinahanglan eksaktong 11 ka digits',
      cityAddressRequired: 'Gikinahanglan ang address sa siyudad',
      emergencyNameRequired: 'Gikinahanglan ang ngalan sa emergency contact',
      emergencyRelationRequired: 'Gikinahanglan ang relasyon sa emergency contact',
      emergencyAddressRequired: 'Gikinahanglan ang address sa emergency contact',
      emergencyContactRequired: 'Gikinahanglan ang numero sa emergency contact',
      emergencyContact11Digits: 'Ang emergency contact kinahanglan eksaktong 11 ka digits',
      preferredPositionRequired: 'Gikinahanglan ang gusto nga posisyon',
      specifyServiceRequired: 'Palihog itukod ang serbisyo nga imong giaplay-an',
      preferredLocationRequired: 'Gikinahanglan ang gusto nga lokasyon',
      positionAppliedRequired: 'Gikinahanglan ang posisyon nga giaplay-an',
      specifyPositionRequired: 'Palihog itukod ang posisyon nga imong giaplay-an',
      agreeRequired: 'Kinahanglan mouyon ka sa mga termino ug kondisyon',
      applicationSubmitted: 'Malampuson nga Nasumite ang Aplikasyon!',
      thankYou: 'Salamat sa imong aplikasyon. Among susihon ang imong impormasyon ug kontakon ka sa dili madugay.',
      submitting: 'Nagsubmit...'
    },
    contact: {
      title: 'Kontaka Kami',
      subtitle: 'Makig-uban kanamo para sa mga pangutana',
      sendMessage: 'Ipadala ang Mensahe',
      yourName: 'Imong Ngalan',
      yourEmail: 'Imong Email',
      yourPhone: 'Imong Telepono',
      subject: 'Subject',
      message: 'Mensahe',
      ourLocation: 'Among Lokasyon',
      phone: 'Telepono',
      email: 'Email',
      address: 'Address',
      officeHours: 'Oras sa Opisina',
      getInTouch: 'Makig-uban Kanamo',
      sendUsMessage: 'Padala og Mensahe'
    },
    footer: {
      description: 'Imong kasaligan nga tighatag sa serbisyo sa manpower sukad 1997.',
      quickLinks: 'Dali nga mga Link',
      ourServices: 'Among Serbisyo',
      contactInfo: 'Impormasyon sa Kontak',
      allRightsReserved: 'Tanang katungod gitagana.',
      cdaRegistered: 'Rehistrado sa CDA'
    },
    common: {
      learnMore: 'Pagkat-on Pa',
      readMore: 'Magbasa Pa',
      submit: 'Isumite',
      loading: 'Nagkarga...',
      viewAll: 'Tan-awa Tanan',
      contactUs: 'Kontaka Kami',
      select: 'Pagpili',
      required: 'Gikinahanglan'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        let fallback = translations['en'];
        for (const fk of keys) {
          if (fallback && typeof fallback === 'object' && fk in fallback) {
            fallback = fallback[fk];
          } else {
            return key;
          }
        }
        return fallback;
      }
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;

